import { render, staticRenderFns } from "./TributeTabSection.vue?vue&type=template&id=2c805052"
import script from "./TributeTabSection.vue?vue&type=script&lang=js"
export * from "./TributeTabSection.vue?vue&type=script&lang=js"
import style0 from "./TributeTabSection.vue?vue&type=style&index=0&id=2c805052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports